import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface QueryScopeState {
  scope?: string; // Optional property
  name?: string; // Optional property
  description?:string;
  folders?: Array<{
    id: number;
    name: string;
    parentFolderId: number | null;
    createdAt?: string;
    createdBy?: number;
    companyId?: number;
    isDeleted?: boolean;

    children?: Array<{
      id: number;
      name: string;
      parentFolderId: number | null;
      createdAt?: string;
      createdBy?: number;
      companyId?: number;
      isDeleted?: boolean;
      updatedAt?: string;
      grandChildren?: Array<{
        id: number;
        name: string;
        parentFolderId: number | null;
        createdAt?: string;
        createdBy?: number;
        companyId?: number;
        isDeleted?: boolean;
        updatedAt?: string;
      }>;
    }>;

    updatedAt?: string;
  }>;
  folderId?: string | number; // Added folderId to the state
}

const initialState: QueryScopeState = {
  name: "",
  scope: localStorage.getItem("scope")
    ? JSON.parse(localStorage.getItem("scope") || "")
    : "",
  folders: localStorage.getItem("folders")
    ? JSON.parse(localStorage.getItem("folders") || "[]")
    : [],
  folderId: undefined, // Added folderId to initial state
  description:undefined
};

const slice = createSlice({
  name: "queryScopeSlice",
  initialState,
  reducers: {
    setQueryScope: (state, action: PayloadAction<QueryScopeState>) => {
      state.scope = action.payload.scope ?? "";

      localStorage.setItem("scope", JSON.stringify(action.payload.scope ?? ""));
    },
    setQueryName: (state, action: PayloadAction<QueryScopeState>) => {
      state.name = action.payload.name ?? "";

      localStorage.setItem(
        "queryName",
        JSON.stringify(action.payload.name ?? "")
      );
    },
    setQueryFolders: (state, action: PayloadAction<QueryScopeState>) => {
      state.folders = action.payload.folders ?? [];

      localStorage.setItem(
        "folders",
        JSON.stringify(action.payload.folders ?? [])
      );
    },

    setQueryFolderId: (state, action: PayloadAction<QueryScopeState>) => {
      state.folderId = action.payload.folderId;
      localStorage.setItem("folderId", JSON.stringify(action.payload.folderId));
    },
    setQueryDescription: (state, action: PayloadAction<QueryScopeState>) => {
      state.description = action.payload.description;
      localStorage.setItem("description", JSON.stringify(action.payload.description));
    },

    resetQueryScope: (state) => {
      const scope = "";
      state.scope = scope;
      localStorage.setItem("scope", JSON.stringify(scope));
    },
  },
});

export const {
  setQueryScope,
  setQueryFolderId,
  setQueryFolders,
  setQueryDescription,
  setQueryName,
  resetQueryScope,
} = slice.actions;
export default slice.reducer;

// Selector
export const getQueryScope = (state: { queryScope: QueryScopeState }) =>
  state.queryScope.scope;
export const getQueryFolders = (state: { queryScope: QueryScopeState }) =>
  state.queryScope.folders;
export const getQueryFolderId = (state: { queryScope: QueryScopeState }) =>
  state.queryScope.folderId;
export const getQueryScopeState = (state: { queryScope: QueryScopeState }) =>
  state.queryScope;
export const getQueryName = (state: { queryScope: QueryScopeState }) =>
  state.queryScope.name;
export const getQueryDescription = (state: { queryScope: QueryScopeState }) =>
  state.queryScope.description;
